<script>
    import { getContext } from "svelte";
    const { height } = getContext("LayerCake");
    
    export let rect_width;
    export let onMouseEvents;
    
    $: padding = 20;
</script>

<pattern
id="diagonalHatch"
patternUnits="userSpaceOnUse"
width="4"
height="4"
>
<path
    d="M-1,1 l2,-2
    M0,4 l4,-4
    M3,5 l2,-2"
    style="stroke:var(--gray-10); stroke-width:{onMouseEvents
        ? 0.5
        : 0.4}"
/>
</pattern>

<rect
    class="legend-rect"
    fill="url(#diagonalHatch)"
    width={rect_width}
    height={rect_width}
    stroke="var(--gray-30)"
    stroke-width=1
    transform={`translate(${padding}, ${$height - rect_width - 3})`}
/>